// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-largeOnWide-text-89da420e"};